'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarEmpty;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function CalendarEmpty(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      className: 'icon-svg-calendar-empty ' + className,
      focusable: 'false',
      'aria-hidden': true,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { d: 'M13.5,2 L12,2 L12,0.3 C12,0.1 11.9,0 11.7,0 L10.3,0 C10.1,0 10,0.1 10,0.3 L10,2 L6,2 L6,0.3 C6,0.1 5.9,0 5.7,0 L4.3,0 C4.1,0 4,0.1 4,0.3 L4,2 L2.5,2 C1.7,2 1,2.7 1,3.5 L1,14.5 C1,15.3 1.7,16 2.5,16 L13.5,16 C14.3,16 15,15.3 15,14.5 L15,3.5 C15,2.7 14.3,2 13.5,2 Z M2.5,14.5 L2.5,5 L13.5,5 L13.5,14.5 L2.5,14.5 Z' })
  );
}

CalendarEmpty.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CalendarEmpty/CalendarEmpty.js
// module id = 165
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16